<template>
  <div class="big">
    <BatchSend
      :batchSendDia.sync="batchSendDia"
      :ids="multipleSelection"
      :user_type="1"
      interfaceName="batchSendConsultSms"
      @refreshList="getList"
    ></BatchSend>
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <ReturnVisit
      :isFlag="return_visit"
      :businessId="consultId"
      :visitType="visitType"
      :visitName="visitName"
      :typeList="typeList"
      :activeIndexDia="activeIndexDia"
      :sms_type="1"
      @refreshList="getList"
    ></ReturnVisit>
    <div class="page_title">咨询记录</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div style="padding: 20px" class="big">
          <div class="searchbox">
            <div class="item">
              <span class="searchtitle">患者姓名</span>
              <el-input
                placeholder="请输入"
                v-model="patient_name"
                class="inputclass"
                @change="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span class="searchtitle">医生姓名</span>
              <el-input
                placeholder="请输入"
                v-model="doctor_name"
                class="inputclass"
                @change="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span class="searchtitle">医生手机号</span>
              <el-input
                placeholder="请输入"
                v-model="doctor_phone"
                class="inputclass"
                clearable
                @change="search"
              ></el-input>
            </div>

            <div class="item">
              <span class="searchtitle">问诊类型</span>
              <el-select
                v-model="consult_type"
                placeholder="请选择"
                class="inputclass"
                clearable
                @change="search"
              >
                <el-option label="全部" :value="0"></el-option>
                <el-option label="患者问诊" :value="1"></el-option>
                <el-option label="医生赠送" :value="2"></el-option>
                <el-option label="诊后咨询" :value="3"></el-option>
                <el-option label="视频问诊" :value="4"></el-option>
                <el-option label="电话问诊" :value="5"></el-option>
                <el-option label="预约视频" :value="6"></el-option>
                <el-option label="极速问诊" :value="7"></el-option>
              </el-select>
            </div>

            <div class="item">
              <span class="searchtitle">咨询状态</span>
              <el-select
                v-model="status"
                placeholder="请选择"
                class="inputclass"
                clearable
                @change="search"
              >
                <el-option label="全部" :value="1"></el-option>
                <el-option label="待接诊" :value="2"></el-option>
                <el-option label="接诊中" :value="3"></el-option>
                <el-option label="已结束" :value="4"></el-option>
                <el-option label="待补充信息" :value="5"></el-option>
              </el-select>
            </div>

            <div class="item">
              <span class="searchtitle">是否已回访</span>
              <span>
                <el-radio-group v-model="is_visit" @change="search">
                  <el-radio :label="''">全部</el-radio>
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </span>
            </div>
            <template v-if="is_visit == 1">
              <div class="item">
                <span class="searchtitle">已回访类型</span>
                <el-select
                  class="input_width"
                  v-model="visit_type"
                  placeholder="请选择"
                  @change="search"
                >
                  <el-option
                    v-for="item in typeList"
                    :key="item.visit_type"
                    :label="item.value"
                    :value="item.visit_type"
                  >
                  </el-option>
                </el-select>
              </div>

              <div class="item">
                <span class="searchtitle">已回访时间</span>
                <el-date-picker
                  v-model="visit_time"
                  type="daterange"
                  range-separator="到"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="search"
                  clearable
                ></el-date-picker>
              </div>
            </template>

            <div class="item">
              <span class="searchtitle">时间</span>
              <el-date-picker
                v-model="date_time"
                type="daterange"
                range-separator="到"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="search"
                clearable
              ></el-date-picker>
            </div>
            <div class="item">
              <el-button
                type="info"
                style="background-color: #eceff2; color: #747981"
                @click="search"
                size="medium"
                >查询</el-button
              >
              <el-button
                type="primary"
                @click="batchSendBtn"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1565') : false
                "
                size="medium"
                >批量发送短信</el-button
              >
            </div>
          </div>
          <div style="border: solid 1px #c9cbd6">
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%; min-width: 1000px"
              :header-cell-style="{ background: '#F5F5F5' }"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column>
                <template slot="header">
                  <div>问诊发起时间/</div>
                  <div>接诊时间</div>
                </template>
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content" v-html="timeText(scope.row)"></div>
                    <div>
                      <!-- <div>{{ scope.row.pay_time }}</div> -->
                      <div v-if="scope.row.is_complain == 1">
                        <div>{{ scope.row.submit_time }}</div>
                        <div>------</div>
                      </div>
                      <div v-else>
                        <div>{{ scope.row.pay_time }}</div>
                        <div
                          v-if="
                            scope.row.status != 0 &&
                            scope.row.status != 1 &&
                            scope.row.status != 2 &&
                            scope.row.status != 4 &&
                            scope.row.status != 6 &&
                            scope.row.status != 8 &&
                            scope.row.status != 11 &&
                            scope.row.status != 12
                          "
                        >
                          {{ scope.row.agree_time }}
                        </div>
                        <div v-else>------</div>
                      </div>
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>

              <el-table-column
                label="问诊费用"
                prop="consult_money"
              ></el-table-column>

              <el-table-column label="实付金额" prop="pay_money">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content">
                      问诊费用:&nbsp;{{ scope.row.consult_money }}元<br />
                      优惠券:&nbsp;-{{ scope.row.coupon_money }}元<br />
                      礼品卡:&nbsp;-{{ scope.row.gift_money }}元<br />
                      合计:&nbsp;{{ scope.row.pay_money }}元<br />
                    </div>
                    <span>{{ scope.row.pay_money }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>

              <el-table-column label="患者信息">
                <template slot-scope="scope">
                  <div>{{ scope.row.real_name }}</div>
                  <div>
                    <span v-if="scope.row.sex == 1">男</span>
                    <span v-if="scope.row.sex == 2">女</span>
                    <span style="margin-left: 10px">{{ scope.row.age }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="医生信息">
                <template slot-scope="scope">
                  <div
                    @click="showDocMsg(scope.row.doctor_id)"
                    style="cursor: pointer"
                  >
                    {{ scope.row.doctor_name }}
                  </div>
                  <div>
                    <span v-if="scope.row.d_sex == 1">男</span>
                    <span v-if="scope.row.d_sex == 2">女</span>
                    <span style="margin-left: 10px">{{ scope.row.title }}</span>
                  </div>
                  <div>{{ scope.row.phone }}</div>
                </template>
              </el-table-column>
              <el-table-column label="问诊类型">
                <template slot-scope="scope">
                  <span
                    v-if="
                      scope.row.consult_type == 1 &&
                      scope.row.consult_types == 1
                    "
                    >患者问诊</span
                  >
                  <span v-if="scope.row.consult_type == 2">医生赠送</span>
                  <span v-if="scope.row.consult_type == 3">诊后咨询</span>
                  <span v-if="scope.row.consult_type == 4">预约视频</span>
                  <span v-if="scope.row.consult_type == 5">极速问诊</span>
                  <span
                    v-if="
                      scope.row.consult_type == 1 &&
                      scope.row.consult_types == 2
                    "
                    >视频问诊</span
                  >
                  <span
                    v-if="
                      scope.row.consult_type == 1 &&
                      scope.row.consult_types == 3
                    "
                    >电话问诊</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="结束时间" prop="over_time">
              </el-table-column>
              <el-table-column label="结束类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 4">拒绝接诊</span>
                  <span v-if="scope.row.status == 5">问诊时间结束</span>
                  <span v-if="scope.row.status == 6">超时未接诊</span>
                  <span v-if="scope.row.status == 7">手动结束</span>
                  <span v-if="scope.row.status == 8">超时未发起</span>
                  <span v-if="scope.row.status == 9">医生退款</span>
                  <span v-if="scope.row.status == 10">平台退款</span>
                  <span v-if="scope.row.status == 11">未接诊平台退款</span>
                  <span v-if="scope.row.status == 12">患者申请退款</span>
                  <span v-if="scope.row.status == 13">患者结束</span>
                </template>
              </el-table-column>
              <el-table-column
                label="是否已回访"
                prop="is_return"
                width="220px"
              >
              </el-table-column>
              <el-table-column label="操作" width="220">
                <template slot-scope="scope">
                  <el-button
                    @click="toReturn(scope.row.consult_id)"
                    type="text"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1315')
                        : false
                    "
                    >回访</el-button
                  >
                  <el-button
                    @click="toReturnList(scope.row.consult_id)"
                    type="text"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1308')
                        : false
                    "
                    >回访记录</el-button
                  >
                  <!-- <el-button @click="setIsReturn(scope.row.consult_id)"
                             type="text"
                             v-if="scope.row.is_return == 0 && laber_code != 'consult_0'"
                             :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1307')
                        : false
                    ">标记为已回访</el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 24px">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalNum"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import DocMsg from "../../../components/common/DocMsg.vue";
import ReturnVisit from "../../../components/common/ReturnVisit.vue";
import BatchSend from "@/components/batchSend/index.vue";

export default {
  data() {
    return {
      batchSendDia: false,
      multipleSelection: [],
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      doctor_name: "",
      doctor_phone: "",
      patient_name: "",
      consult_type: "",
      status: "",
      // laber_code: 'consult_0',
      is_visit: "",
      visit_type: "",
      visit_time: [],
      date_time: [],
      typeList: [],
      doc_msg: false,
      doctorId: "",
      return_visit: false,
      consultId: 0,
      visitName: "consult",
      visitType: 4,
      activeIndexDia: "1",
    };
  },
  components: {
    DocMsg,
    ReturnVisit,
    BatchSend,
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.initDate();
    this.getVisitType();
  },
  methods: {
    // 问诊接诊时间文案
    timeText(row) {
      let { status, submit_time, agree_time, pay_time, is_complain } = row;
      let submit_html = `<div>问诊发起时间:${
        is_complain == 1 ? submit_time : pay_time
      }</div>`;
      let agree_html =
        status != 0 &&
        status != 1 &&
        status != 2 &&
        status != 4 &&
        status != 6 &&
        status != 8 &&
        status != 11 &&
        status != 12
          ? `<div>接诊时间:${agree_time}-${status}</div>`
          : `<div>接诊时间:------</div>`;
      let pay_html = `<div>支付时间:${pay_time}</div>`;
      return `${pay_html}${submit_html}${agree_html}`;
    },
    initDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      end = dayjs(end).format("YYYY-MM-DD");
      start = dayjs(start).format("YYYY-MM-DD");
      this.date_time = [start, end];
    },
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取回访类型
    getVisitType() {
      this.axios
        .post("platform/Clientreview/getVisitType", {
          visit_type: "consult",
        })
        .then((res) => {
          if (res.code == 0) {
            this.typeList = res.data.list;
            // this.laber_code = res.data.laber_code
            //   ? res.data.laber_code
            //   : 'consult_0';
            this.getList();
          }
        });
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        doctor_phone: this.doctor_phone,
        patient_name: this.patient_name,
        consult_type: this.consult_type,
        // laber_code: this.laber_code,
        is_visit: this.is_visit,
        status: this.status,
      };
      data.date_start_time = this.date_time ? this.date_time[0] : "";
      data.date_end_time = this.date_time ? this.date_time[1] : "";
      if (this.is_visit == 1) {
        data.visit_start_time = this.visit_time ? this.visit_time[0] : "";
        data.visit_end_time = this.visit_time ? this.visit_time[1] : "";
        data.visit_type = this.visit_type;
      }
      this.axios.post("platform/Clientreview/consultList", data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.submit_time = item.submit_time
              ? dayjs.unix(item.submit_time).format("YYYY-MM-DD HH:mm")
              : "--------";
            item.agree_time = item.agree_time
              ? dayjs.unix(item.agree_time).format("YYYY-MM-DD HH:mm")
              : "--------";
            item.pay_time = item.pay_time
              ? dayjs.unix(item.pay_time).format("YYYY-MM-DD HH:mm")
              : "---------";
            item.over_time = item.over_time
              ? dayjs.unix(item.over_time).format("YYYY-MM-DD HH:mm")
              : "";
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //设置标记已回访
    setIsReturn(consult_id) {
      let data = {
        laber_code: this.laber_code,
        visit_type: "consult",
        visit_type_id: consult_id,
      };
      this.axios.post("platform/Clientreview/setIsReturn", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("已标记为已回访");
        }
        this.getList();
      });
    },
    //回访
    toReturn(consult_id) {
      this.consultId = consult_id;
      this.activeIndexDia = "1";
      this.return_visit = !this.return_visit;
    },
    //回访记录
    toReturnList(consult_id) {
      this.consultId = consult_id;
      this.activeIndexDia = "2";
      this.return_visit = !this.return_visit;
    },
    // 批量发送短信
    handleSelectionChange(val) {
      this.multipleSelection = val.map((item) => item.consult_id);
    },
    batchSendBtn() {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择");
        return;
      }
      this.batchSendDia = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding-bottom: 20px;
}
.noneline {
  border: 0;
  padding: 0 20px;
}
.title {
  font-size: 16px;
  width: 90px;
}

.searchbox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .item {
    margin-right: 16px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
  }
  .inputclass {
    width: 160px;
  }
  .searchtitle {
    display: inline-block;
    width: 70px;
    text-align: right;
    box-sizing: border-box;
    margin-right: 8px;
  }
}
</style>
